<oaibox-warning-message-card
  gradient="danger"
  confirmText="Delete"
  (confirm$)="deleteOrder()"
  (cancel$)="cancel()"
>
  <div messageTitle>Are you sure you want to delete this Order?</div>
  <div messageBody class="content">
    <oaibox-order-details [order]="order"></oaibox-order-details>
  </div>
</oaibox-warning-message-card>
